import React from 'react';
import css from './ZnanyLekaz.module.css';
import MiniPhoto from '../../images/DawidFoto3.png';

const ZnanyLekaz = () => {
    const isSubmitting = false;

    const openZnanyLekarz = () => {
        if (process.env.REACT_APP_ZNANYLEKARZ_URL) {
            window.open(process.env.REACT_APP_ZNANYLEKARZ_URL, "_blank", "noopener,noreferrer");
        } else {
            console.error("REACT_APP_ZNANYLEKARZ_URL не задано у .env");
        }
    };

    return (
        <section className={css.lekazSection}>
            <img src="/logoZnanyLekarz.png" alt="Znany Lekarz Logo" className={css.logoZnanyLekarz} />

            <div className={css.lekazContainer}>
                <img src={MiniPhoto} alt="Mini Photo Dawid Lewko" className={css.miniPhoto} />

                <div className={css.lekazTextContainer}>
                    <h2 className={css.lekazTitle}>mgr Dawid Lewko</h2>
                    <p className={css.lekazText}>Psycholog</p>

                    <div className={css.buttonContainer}>
                        <button
                            className={css.submitButton}
                            type="button"
                            disabled={isSubmitting}
                            onClick={() => window.open(process.env.REACT_APP_ZNANYLEKARZ_URL, "_blank")}
                        >
                            Umów wizytę
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ZnanyLekaz;
